<fcp-floating-button
    class="fc-back-to-top-button"
    [iconName]="['fas', 'arrow-up-long']"
    [ngClass]="{ 'fc-back-to-top-button-show': windowScrolled }"
    (click)="scrollToTop()"
>
</fcp-floating-button>
